module.exports = __webpack_public_path__ + "img/FGr_Brückenbau_A.9b42f076.svg";